import { supabase } from '../lib/supabase';

export async function generateInvoiceNumber(): Promise<string> {
  try {
    // Get the current date in YYYYMM format
    const now = new Date();
    const yearMonth = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}`;
    
    // Find the last invoice number for this month
    const { data, error } = await supabase
      .from('vehicle_service_history')
      .select('invoice_number')
      .like('invoice_number', `INV-${yearMonth}%`)
      .order('invoice_number', { ascending: false })
      .limit(1);
    
    if (error) throw error;
    
    let sequenceNumber = 1;
    
    if (data && data.length > 0 && data[0].invoice_number) {
      // Extract the sequence number from the last invoice
      const lastInvoiceNumber = data[0].invoice_number;
      const match = lastInvoiceNumber.match(/INV-\d{6}(\d{3})/);
      if (match && match[1]) {
        sequenceNumber = parseInt(match[1]) + 1;
      }
    }
    
    // Format: INV-YYYYMMNNN (e.g., INV-202401001)
    return `INV-${yearMonth}${String(sequenceNumber).padStart(3, '0')}`;
    
  } catch (error) {
    console.error('Error generating invoice number:', error);
    // Fallback to timestamp-based number
    return `INV-${Date.now()}`;
  }
}

export async function generateJobNumber(): Promise<string> {
  try {
    // Get the current date in YYYYMM format
    const now = new Date();
    const yearMonth = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}`;
    
    // Find the last job number for this month
    const { data, error } = await supabase
      .from('service_jobs')
      .select('job_number')
      .like('job_number', `JOB-${yearMonth}%`)
      .order('job_number', { ascending: false })
      .limit(1);
    
    if (error) throw error;
    
    let sequenceNumber = 1;
    
    if (data && data.length > 0 && data[0].job_number) {
      // Extract the sequence number from the last job
      const lastJobNumber = data[0].job_number;
      const match = lastJobNumber.match(/JOB-\d{6}(\d{3})/);
      if (match && match[1]) {
        sequenceNumber = parseInt(match[1]) + 1;
      }
    }
    
    // Format: JOB-YYYYMMNNN (e.g., JOB-202401001)
    return `JOB-${yearMonth}${String(sequenceNumber).padStart(3, '0')}`;
    
  } catch (error) {
    console.error('Error generating job number:', error);
    // Fallback to timestamp-based number
    return `JOB-${Date.now()}`;
  }
}